import { call, getContext, put, takeLatest } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* updateBasketProductAnalytics(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const analyticsGoogleTagManagerData = yield call(BasketAPI.updateBasketProductAnalytics, action.payload.product, action.payload.quantity, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createUpdateGoogleAnalyticsSuccessAction(analyticsGoogleTagManagerData));
        const analyticsAdobeTagManagerData = yield call(BasketAPI.updateBasketProductDtm, action.payload.product, action.payload.quantity, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createUpdateAdobeAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
export function* updateBasketProductAnalyticsSaga() {
    yield takeLatest(BasketActionTypes.UPDATE_PRODUCT_SUCCESS, updateBasketProductAnalytics);
}
